import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";
import { MyApi } from "../MyApi";

export default function PhotoGalleryCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(MyApi.BASE_URL + "gallery-cat", {
          headers: { Authorization: MyApi.SECRET_KEY },
        });
        if (res.data?.status) {
          setCategories(res.data.gallery_category || []);
        }
      } catch (err) {
        console.error("API Error:", err);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  if (loading) return <p className="text-center py-5">Loading categories...</p>;

  return (
  <>
   <div className="BreadcrumbStyle">
        <Container>
          <h1>Photo Gallery</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Photo Gallery</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
      </div>
    <Container className="py-4">
      <Row className="g-4">
        {categories.map((cat) => (
          <Col md={3} sm={4} xs={6} key={cat.id} className="text-center">
            <Link to={`/photo-gallery/${cat.id}`}>
              <div className="category-card" style={{ cursor: "pointer" }}>
                <img
                  src={cat.image_url}
                  alt={cat.gallerytitle}
                  className="img-fluid rounded gallery_img_cat"
                />
                <h6 className="mt-2">{cat.gallerytitle}</h6>
              </div>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
    </>
  );
}
